class HeroSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.dataset.slider == "true") {
      this.slides = this.querySelector(".hero-section__slides");
      this.controls = this.querySelector(".hero__dots");
      this.initFlickity();
    }
  }

  initFlickity() {
    const dots = this.dataset.dots === "true" ? true : false;
    const arrows = this.dataset.arrows === "true" ? true : false;
    this.flickity = new Flickity(this.slides, {
      accessibility: false,
      rightToLeft: theme.config.rtl,
      prevNextButtons: arrows,
      arrowShape:
        "M38.39,17.65a3.91,3.91,0,0,0-1.12-1.51,3.83,3.83,0,0,0-1.69-.8A3.84,3.84,0,0,0,32.1,16.4L1.33,47.17a3.83,3.83,0,0,0-.83,4.2,3.85,3.85,0,0,0,.83,1.25L32.1,83.38a3.81,3.81,0,0,0,2.72,1.13,3.85,3.85,0,0,0,2.73-6.57L13.34,53.74h83a3.85,3.85,0,1,0,0-7.69h-83l24.21-24.2a3.8,3.8,0,0,0,1.05-2A3.86,3.86,0,0,0,38.39,17.65Z",
      pageDots: dots,
      wrapAround: true,
      cellAlign: "left",
      autoPlay: this.dataset.auto == "false" ? false : parseInt(this.dataset.auto),
      selectedAttraction: 0.02,
      friction: 0.25,
      adaptiveHeight: true,
      percentPosition: false,
      imagesLoaded: true,
    });

    window.onload = function(){
      window.dispatchEvent(new Event('resize'));
    }

    // NOTE: the hero has NO separate dots/controls carousel — hero.liquid renders
    // only `.hero-section__slides`, and the dots/arrows are Flickity's own
    // (pageDots/prevNextButtons above). The `this.flickityControls` handlers that
    // used to live here were vestigial copy-paste from shop-the-look (which DOES
    // have a controls carousel). `this.flickityControls` was never instantiated,
    // so `this.flickityControls.on(...)` threw on EVERY multi-slide hero load and
    // aborted init; the staticClick handler also threw on slide clicks. Removed.
  }
}
if (!customElements.get("hero-section")) {
  customElements.define("hero-section", HeroSection);
}

if (typeof module !== "undefined" && module.exports) {
  module.exports = HeroSection;
}

// Trigger Flickity initialization when section is loaded in the editor
// NOTE: `.hero-section` below matches the WRAPPER DIV (class), not the
// <hero-section> custom element (tag) — so initFlickity() is called on a plain
// div and throws in the theme editor. Editor-only; left as a follow-up because a
// naive selector fix would re-run initFlickity on already-Flickity'd slides
// (double-init). See assets/THEME-JS-BUGHUNT.md.
document.addEventListener("shopify:section:load", function(event) {
  const sectionId = event.detail.sectionId;
  const section = document.getElementById(sectionId);
  if (section) {
    const flickitySection = section.querySelector(".hero-section");
    if (flickitySection) {
      flickitySection.initFlickity();
    }
  }
});
